import { createBrowserHistory } from 'history';

const baseTag = document.getElementsByTagName('base');
const baseHref = baseTag.length > 0 && baseTag[0].getAttribute('href') ? baseTag[0].getAttribute('href') : '';

export const HISTORY = createBrowserHistory({
    basename: baseHref || undefined
});

export default HISTORY;
